const infoIcon = "/assets/img/modalIcons/infoIcon.svg";
const errorIcon = "/assets/img/modalIcons/errorIcon.svg";
const refundIcon = "/assets/img/modalIcons/refundIcon.svg";
const signoutIcon = "/assets/img/modalIcons/signoutIcon.svg";
const discardIcon = "/assets/img/modalIcons/discardIcon.svg";

export const ModalData = {
    info: { 
        HeaderStyle:"infoHeader",
        FooterStyle:"infoModalFooter",
        ContentStyle:"infoContent",
        header: {
            image: infoIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            } 
        }
    },
     missingDocNotifModal: { 
        HeaderStyle:"",
        FooterStyle:"",
        ContentStyle:"",
        header: {
            image: infoIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"450px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:"235px 1fr 95px"
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"450px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:"235px 1fr 95px"
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"450px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:"235px 1fr 95px"
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"450px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:"235px 1fr 95px"
            } 
        }
    },
    UpdateMarketValueModal:{ 
        HeaderStyle:"", // using default header styling
        FooterStyle:"", // using default footer styling
        ContentStyle:"", // using default content styling
        header: {
            image: infoIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"500px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"485px",
                    minWidth:""
                },
                gridLayout:""
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"500px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"485px",
                    minWidth:""
                },
                gridLayout:""
            } 
        }
    },
    filterModal: { 
        HeaderStyle:"filterHeader",
        FooterStyle:"filterFooter",
        ContentStyle:"",
        header: {
            image: ""
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:"55px 1fr 115px"
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:"55px 1fr 115px"
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"500px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"485px",
                    minWidth:""
                },
                gridLayout:"55px 1fr 85px"
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"500px",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"485px",
                    minWidth:""
                },
                gridLayout:"55px 1fr 85px"
            } 
        }
    },
    error: { 
        HeaderStyle:"errorHeader",
        FooterStyle:"infoModalFooter",
        ContentStyle:"errorContent",
        header: {
            image: errorIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            } 
        }
    },
    refund: { 
        HeaderStyle:"infoHeader",
        FooterStyle:"refundModalFooter",
        ContentStyle:"infoContent",
        header: {
            image: refundIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            } 
        }
    },
    signout: { 
        HeaderStyle:"signoutinfoHeader",
        FooterStyle:"infoModalFooter",
        ContentStyle:"infoContent",
        header: {
            image: signoutIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            } 
        }
    },
    discard: { 
        HeaderStyle:"discardinfoHeader",
        FooterStyle:"infoModalFooter",
        ContentStyle:"infoContent",
        header: {
            image: discardIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            } 
        }
    },
    action: { 
        HeaderStyle:"actionHeader",
        FooterStyle:"infoModalFooter",
        ContentStyle:"infoContent",
        header: {
            image: infoIcon
        },
        customSize:{
            smallMobile: {
                breakpoint: 460, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"",
                    minWidth:""
                },
                gridLayout:""
            },
            mobile: {
                breakpoint: 570, // anything below 570 is mobile
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"600px",
                    minWidth:""
                },
                gridLayout:""
            },
            tablet: {
                breakpoint: 768, // anything below 768 is tablet
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"600px",
                    minWidth:""
                },
                gridLayout:""
            },
            desktop: {
                breakpoint: 1200, // anything above 1200 is desktop
                customHeight: {
                    height:"",
                    maxHeight:"",
                    minHeight:""
                },
                customWidth: {
                    width:"",
                    maxWidth:"600px",
                    minWidth:""
                },
                gridLayout:""
            } 
        }
    },
};